
export enum NAV_MENU_TYPE {
    /**
     * 社区类型
     */
    COMMUNITY = 'COMMUNITY',
    /**
     * 历史记录类型
     */
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_MIND = 'TECH_MIND',
    MATERIAL_MIND = 'MATERIAL_MIND',
    IDEA_EXPLORATION = 'IDEA_EXPLORATION',
    TECH_RESEARCH = 'TECH_RESEARCH',
    TECH_FMEA = 'TECH_FMEA',
    PATENT_DISCLOSURE = 'PATENT_DISCLOSURE',
    AI_GENERATE = 'AI_GENERATE',
    LS_DOCUMENT_QA = 'LS_DOCUMENT_QA',
    LS_CHAT = 'LS_CHAT',
    LS_MARKUSH_PATENT_DRAFT = 'LS_MARKUSH_PATENT_DRAFT',
    TRIZ_MIND = 'TRIZ_MIND',
    RD_TECH_MIND = 'RD_TECH_MIND',

    HOME = 'HOME',
    CUSTOM_AGENT = 'CUSTOM_AGENT',
    AI_STUDIO = 'AI_STUDIO',
    MONITOR = 'MONITOR',
    MONITOR_TOPIC = 'MONITOR_TOPIC',
    MONITOR_SUBSCRIPTION = 'MONITOR_LIST',
    WORK_PROJECT = 'WORK_PROJECT',
    HISTORY = 'HISTORY',
    INCOGNITO = 'INCOGNITO',
    TECH_RISK = 'TECH_RISK',
    TRIZ = 'TRIZ',
    SEARCH_TASK = 'SEARCH_TASK',
    NEW_TASK = 'NEW_TASK' // 新建搜索任务
}

export enum IMenuType {
    /**
     * FMEA 创建历史
     */
    TECH_FMEA = 'TECH_FMEA',
    /**
     * techResearch的历史
     */
    TECH_RESEARCH = 'TECH_RESEARCH',

    RD_TECH_MIND = 'RD_TECH_MIND',
    /**
     * AI专利交底书
     */
    PATENT_DISCLOSURE = 'PATENT_DISCLOSURE',
    /**
     * 专利翻译
     */
    AI_TRANSLATION = 'AI_TRANSLATION',

    /**
     * 专利说明书撰写
     */
    AI_SPECIFICATION = 'AI_SPECIFICATION',

    /**
     * 技术交底书撰写
     */
    AI_PATENT_DISCLOSURE = 'AI_PATENT_DISCLOSURE',

    /**
     * 查新检索
     */
    AI_NOVELTY_SEARCH = 'AI_NOVELTY_SEARCH',

    /**
     * 防侵权检索
     */
    AI_FTO_SEARCH = 'AI_FTO_SEARCH',

    /**
     * 防侵权检索（新）
     */
    AI_NEW_FTO_SEARCH = 'AI_NEW_FTO_SEARCH',

    /**
     * TRIZ思维导图
     */
    TRIZ_MIND = 'TRIZ_MIND',

    /**
     * company search agent
     */
    COMPANY_SCOUT = 'COMPANY_SCOUT',

    /**
     * RD plg
     */
    PLG_QA = 'PLG_QA',

    /**
     * 百科问答
     */
    LS_CHAT = 'LS_CHAT'
}

export interface NavMenuItem {
    /**
     * 菜单类型，唯一标识
     */
    type: NAV_MENU_TYPE;
    /**
     * 菜单标题
     */
    title?: string;
    /**
     * 菜单链接，历史记录数据是后端返回的，其余是前端配置的
     */
    link?: string;
    /**
     * 菜单图标
     */
    icon?: string;
    /**
     * 菜单模块，多包下区分是不是同一个模块，是的话需要使用vue-router进行跳转
     */
    module?: NAV_MENU_TYPE;
    /**
     * 路由名称(用于vue-router)
     */
    router?: string;
    /**
     * 历史记录ID，用于删除历史记录
     */
    id?: string;
    /**
     * 子菜单
     */
    children?: NavMenuItem[];
    /**
     * 是否是当前选中状态
     */
    active?: boolean;
    /**
     * 点击菜单事件,TODO 需要改组件库可去除这个参数
     */
    onClick?: () => void;
}

export interface HistoryRowData {
    /**
     * 跳转参数链接
     */
    link: string,
    /**
     * 历史记录标题
     */
    title: string,
    /**
     * 历史记录类型
     */
    source: NAV_MENU_TYPE,
    /**
     * 历史记录ID
     */
    id: string,
    /**
     * 历史记录创建时间
     */
    created_at: string,
    /**
     * 是否是当前选中状态
     */
    active?: boolean,
    /**
     * 历史记录图标
     */
    icon_url?: string,
    /**
     * 历史记录业务名称
     */
    business_name?: string,
}

export interface NavHistoryResponse {
    limit: number,
    page: number,
    history_maps: {
        date: string,
        data: HistoryRowData[]
    }[]
}
